/*******************************************************************************
 * Urgency Step Actions and Reducer
 */

import {
	ActionMap,
	FormContext_Action_Payload,
} from '@/components/forms/FormContext';
import { ReplaceVirtuallyFormState, StepMap } from '../../constants';

export const UrgencyStepActions = {
	UPDATE_URGENCY: 'UPDATE_URGENCY',
} as const;

export type UrgencyStepAction = keyof typeof UrgencyStepActions;

export interface UrgencyStepActionPayload
	extends FormContext_Action_Payload<StepMap> {
	[UrgencyStepActions.UPDATE_URGENCY]: string;
}

export type UrgencyStepActionMap =
	ActionMap<UrgencyStepActionPayload>[keyof ActionMap<UrgencyStepActionPayload>];

export const isUrgencyStepActionMap = (
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	action: any,
): action is UrgencyStepActionMap => action.type in UrgencyStepActions;

export const urgencyStepReducer = (
	state: ReplaceVirtuallyFormState,
	action: UrgencyStepActionMap,
): ReplaceVirtuallyFormState => {
	switch (action.type) {
		case UrgencyStepActions.UPDATE_URGENCY:
			return {
				...state,
				urgency: action.payload,
			};
		default:
			return state;
	}
};

export const isValid = (state: ReplaceVirtuallyFormState): boolean => {
	const { urgency } = state;
	return !!urgency;
};
